import { Component } from 'react';
import dateUtils from '../common/utilities/DateUtilities';
import Calendar from "react-range-calendar";
import {
    addDays, subDays, endOfDay, startOfDay, startOfMonth, endOfMonth, addMonths,
    startOfWeek, endOfWeek, isSameDay, differenceInCalendarDays, addYears, startOfYear, endOfYear,
} from 'date-fns';

class DateTimeFilter extends Component {

    state = {
        visible: true,
        dateRange: [new Date(), addDays(new Date(), 0)]
    };


    reactRangeCalendar = (labelData, dateOptions) => {

        const { visible, dateRange } = this.state;
        const steps = 7;
        const startWithDay = "Wed";

        switch (labelData.toUpperCase()) {
            case "AFTER":
                return (
                    <Calendar
                        visible={this.state.visible}
                        dateRange={dateRange}
                        onDateClick={date => {
                            this.setState({ dateRange: [date], visible: false });
                        }}
                        type="single"
                    />
                );

            case "BEFORE":
                return (
                    <Calendar
                        visible={visible}
                        dateRange={dateRange}
                        onDateClick={date => {
                            this.setState({ dateRange: [date],  });
                        }}
                        type="single"
                    />
                );

            case "CUSTOM RANGE":
                return (
                    <Calendar
                        visible={visible}
                        // steps={steps}
                        // startWithDay={startWithDay}
                        dateRange={dateRange}
                        onDateClick={(minDate, maxDate) => {
                            this.setState({ dateRange: [minDate, maxDate] });
                        }}
                        type="free-range"
                    />
                );
        }
    }

    getDateTimeOperatorByTimeStamp = (label) => {
        switch (label.toUpperCase()) {
            // case "TODAY":
            //     return [startOfDay(new Date())];

            // case "YESTERDAY":
            //     return [startOfDay(addDays(new Date(), -1))];

            // case "THIS WEEK":
            //     return [startOfWeek(new Date()), endOfWeek(new Date())]

            case "TODAY":
                return [(new Date())];

            case "YESTERDAY":
                return [(addDays(new Date(), -1))];

            case "THIS WEEK":
                return [(new Date()), endOfWeek(new Date())];

            case "LAST WEEK":
                return [startOfWeek(addDays(new Date(), -7)), endOfWeek(addDays(new Date(), -7))];

            case "LAST TWO WEEK":
                return [startOfWeek(addDays(new Date(), -14)), endOfWeek(addDays(new Date(), -7))];

            case "THIS MONTH":
                return [startOfMonth(new Date()), endOfMonth(new Date())];

            case "LAST MONTH":
                return [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))];

            case "LAST TWO MONTH":
                return [startOfMonth(addMonths(new Date(), -2)), endOfMonth(addMonths(new Date(), -1))];

            case "AFTER":
                return this.reactRangeCalendar("AFTER");
            default:
                break;
        }
    }

    convertFormattedDatTimeByTimeStamp = (label, type) => {
        var resultedDate;
        var newData = this.getDateTimeOperatorByTimeStamp(label);
        if (type === "DATE") {
            if (newData.length === 1) {
                resultedDate = dateUtils.getCalendarFormattedDateByTimeStamp(newData[0])
            }

            if (newData.length === 2) {
                resultedDate = `${dateUtils.getCalendarFormattedDateByTimeStamp(newData[0])}#${dateUtils.getCalendarFormattedDateByTimeStamp(newData[1])}`;
            }

            return resultedDate;
        } else if (type === "DATETIME") {
            if (newData.length === 1) {
                resultedDate = dateUtils.getFormattedDateTimeForDateTimeColumns(newData[0])
            }

            if (newData.length === 2) {
                resultedDate = `${dateUtils.getFormattedDateTimeForDateTimeColumns(newData[0])}#${dateUtils.getFormattedDateTimeForDateTimeColumns(newData[1])}`;
            }
        }
        return resultedDate;
    }
}

export default new DateTimeFilter();